export const variables = {
  colors: {
    'background': '#F0F2F5',
    'base-white': '#fff',
    'base-grey': '#3A4B68',
    'grey': '#777777',
    'road-grey': '#44527B',
    'road-grey-100': '#ECEEF2',
    'road-grey-200': '#DADCE5',
    'road-grey-500': '#A1A8BD',
    'road-grey-600': '#8F97B0',
    'road-grey-700': '#576388',
    'road-grey-800': '#697595',
    'road-grey-900': '#576388',
    'road-grey-030': '#F9F9FB',
    'road-grey-080': '#F0F2F5',
    'road-grey-090': '#677498',
    'road-grey-90%': '#44527B',
    'road-grey-5-perc': 'rgba(68, 82, 123, 0.05);',
    'snow-white-70%': 'rgba(252, 253, 255, 0.7)',
    'blue': '#3197C8',
    'dark-sea-blue': '#56B2CF',
    'light-sea-blue': '#E5FAFF',
    'brand-primary-blue': '#3097E1',
    'dark-mandarin-orange': '#EA8054',
    'light-mandarin-orange': '#FFF0EA',
    'delimiter': '#F0F1F5',
  },

  sizes: {
    '0': '0px',
    '7': '7px',
    '8': '8px',
    '9': '9px',
    '10': '10px',
    '11': '11px',
    '12': '12px',
    '14': '14px',
    '18': '18px',
    '22': '22px',
    '24': '24px'
  },

  weight: {
    '300': '300',
    '400': '400',
    '500': '500',
    '700': '700'
  },

  gutter: {
    '0': '0px',
    '1': '1px',
    '3': '3px',
    '4': '4px',
    '6': '6px',
    '-6': '-6px',
    '7': '7px',
    '-7': '-7px',
    '8': '8px',
    '10': '10px',
    '-10': '-10px',
    '12': '12px',
    '15': '15px',
    '17': '17px',
    '18': '18px',
    '20': '20px',
    '24': '24px',
    '26': '26px',
    '-18': '-18px'
  }
}

export type ColorsType = keyof typeof variables.colors;
export type SizesType =  keyof typeof variables.sizes;
export type WeightType = keyof typeof variables.weight;
export type GutterType = keyof typeof variables.gutter;
